/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";
import SVG from "react-inlinesvg";
import {Dropdown,Button} from "react-bootstrap";
import {toAbsoluteUrl} from "../../../_helpers";
import {DropdownCustomToggler, DashboardUserMenu} from "../../dropdowns";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";

export function DashboardUsersList({ className,users=[],onDelete }) {
	const { t } = useTranslation('common')
	return (
		<>
			<div className={`card card-custom bg-light-success ${className}`}>
				{/* Head */}
				<div className="card-header border-0">
					<h3 className="card-title text-success font-weight-bolder text-dark">{t('LatestUsers')}</h3>
					<div className="card-toolbar">
						<Link to={'/user/new'}><Button variant="outline-primary">{t('MENU.NEW')}</Button></Link>
					</div>
				</div>
				{/* Body */}
				<div className="card-body pt-2">
					{users.map((user,index)=>
						<div key={index} className="d-flex align-items-center mb-10">
							<div className="symbol symbol-40 symbol-light-success mr-5">
              <span className="symbol-label">
                <SVG
									className="h-75 align-self-end"
									src={toAbsoluteUrl("/media/svg/avatars/009-boy-4.svg")}
								/>
              </span>
							</div>
							<div className="d-flex flex-column flex-grow-1 font-weight-bold">
								<a
									href="#"
									className="text-dark text-hover-primary mb-1 font-size-lg"
								>
									{user.name}
								</a>
								<span className="text-muted">#{user.id}</span>
							</div>
							<ItemDropdown item={user} onDelete={()=>onDelete(user.id)}/>
						</div>
					)}
				</div>
			</div>
		</>
	);
}

const ItemDropdown = ({item,onDelete}) => {
	return (<>
		<Dropdown className="dropdown-inline" alignRight>
			<Dropdown.Toggle
				id="dropdown-toggle-top"
				as={DropdownCustomToggler}>
				<i className="ki ki-bold-more-hor" />
			</Dropdown.Toggle>
			<Dropdown.Menu className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
				<DashboardUserMenu item={item} onDelete={onDelete}/>
			</Dropdown.Menu>
		</Dropdown>
	</>);
};
